import React, { useEffect, useState } from 'react';

import { Modal, Button, Form, FormItemProps, Input, notification, Select } from 'antd';

import { ErrorRender, FormErrorParser } from '@partsbadger/library';
import { PlusOutlined } from '@ant-design/icons';

import QuoteStore from '../../../stores/QuoteStore';

import PartStore from 'stores/PartStore';

interface IProps {
    showCreateGroup: boolean;
    onClose: () => void;
}

const CreateNewGroup: React.FC<IProps> = ({ showCreateGroup, onClose }) => {
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();

    const handleSubmit = () => {
        setLoading(true);
        form.validateFields()
            .then(async values => {
                const groupName = values.name;

                await PartStore.createPartsGroup(groupName)
                    .then(() => {
                        notification.success({
                            message: 'The group has been created successfully.',
                            description: 'The group has been created and you can find it in the Group list.',
                            placement: 'topRight',
                        });

                        onClose();
                    })
                    .catch((err: any) => {
                        notification.error({
                            message: <ErrorRender error={err} />,
                            placement: 'topRight',
                        });
                    });

                setLoading(false);
            })
            .catch(errorInfo => {
                setLoading(false);

                notification.error({
                    key: 'form-errors',
                    duration: 8,
                    message: 'Please input all required fields',
                    description: <FormErrorParser isAntd4 errors={errorInfo.errorFields} />,
                    placement: 'top',
                    maxCount: 1,
                });
            });
    };

    const formItemLayout: FormItemProps = {
        labelCol: { span: 24 },
        wrapperCol: { span: 22 },
        labelAlign: 'left',
    };

    return (
        <div>
            <Modal
                open={showCreateGroup}
                title="New Group"
                width={600}
                destroyOnClose={true}
                onCancel={() => onClose()}
                // bodyStyle={{ overflowY: 'scroll', overflowX: 'auto', height: '60vh' }}
                footer={[
                    <>
                        <div key={1} className="flex justify-between">
                            <Button
                                onClick={() => {
                                    onClose();
                                }}
                                size="large"
                                loading={loading}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                loading={loading}
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </>,
                ]}
            >
                <Form form={form}>
                    <div className="flex flex-col">
                        <p>
                            Group your parts for assemblies or other packages for quick parts management on a New Group.
                        </p>

                        <div>
                            <Form.Item
                                label="Group Name"
                                {...formItemLayout}
                                name="name"
                                rules={[{ required: true, message: 'Please input a name' }]}
                                className="w-full"
                            >
                                <Input
                                    className="w-full"
                                    minLength={5}
                                    maxLength={200}
                                    placeholder="Please enter your New Group Name"
                                />
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        </div>
    );
};

export default CreateNewGroup;
